// 课程设计 detail page, profile, register, reset
const en = {
  // plan-detail
  "这一部分": "(this part)",
  "课时标题": "Lesson title",
  "课时设计内容": "Lesson design",
  "总体设计 = 基本信息 {completion.basic}% · 课程设计 {completion.design}%；分课时设计、实施各共 {completion.lessonCount} 课时，每课时实施 = 实施记录 50% + 支撑材料 50%（按上次保存的内容计算）":
    "Overall design = basic info {completion.basic}% · course design {completion.design}%; lesson design and implementation each cover {completion.lessonCount} lessons, each lesson's implementation = record 50% + materials 50% (based on the last saved content)",
  "总体设计完成度：{completion.general}% · 分课时设计完成度：{completion.lessonDesign}% · 实施完成度：{completion.execution}%":
    "Overall design: {completion.general}% · Lesson design: {completion.lessonDesign}% · Implementation: {completion.execution}%",
  "没有未保存的修改": "No unsaved changes",
  "保存草稿": "Save draft",
  "请先填写 WHY/WHAT/HOW、分课时设计或实施记录后再提交": "Fill in WHY/WHAT/HOW, a lesson design or an implementation record before submitting",
  "提交待点评": "Submit for review",
  "乡土课程设计方案": "Course design",
  "预览失败。": "Preview failed.",
  "仅支持上传 .docx 文件。": "Only .docx files can be uploaded.",
  "上传新文件将覆盖当前课程设计方案的全部在线内容（WHY/WHAT/HOW 及分课时设计），且无法撤销，确定继续吗？":
    "Uploading a new file will overwrite all of this course design's online content (WHY/WHAT/HOW and lesson designs) and cannot be undone. Continue?",
  "课程设计文件已上传，在线内容已更新。": "Course design file uploaded; online content updated.",
  "上传失败，请确认文件格式。": "Upload failed. Please check the file format.",
  "下载中...": "Downloading...",
  "“下载”“预览”均根据课程设计方案的当前在线内容实时生成，不保存文件，每次都反映最新内容；预览将在新窗口中打开。":
    "\"Download\" and \"Preview\" are generated live from the course design's current online content, so they always reflect the latest version. Preview opens in a new window.",
  "上传课程设计文件（将覆盖当前在线内容）": "Upload a course design file (overwrites the current online content)",
  "正在解析并上传...": "Parsing and uploading...",
  "拖拽 .docx 文件到这里，或点击选择文件以覆盖当前内容": "Drag a .docx file here, or click to choose one, to overwrite the current content",
  "上传的文件将替换当前的 WHY/WHAT/HOW 及分课时设计内容，此操作无法撤销。": "The uploaded file replaces the current WHY/WHAT/HOW and lesson designs. This cannot be undone.",
  "{0}-课时{lessonIndex}-实施记录.docx": "{0}-lesson{lessonIndex}-implementation-record.docx",
  "上传新文件将覆盖本课时当前的实施记录内容，且无法撤销，确定继续吗？":
    "Uploading a new file will overwrite this lesson's current implementation record and cannot be undone. Continue?",
  "课程实施文件已上传，实施记录已更新。": "Implementation file uploaded; record updated.",
  "“下载”“预览”均根据本课时的当前实施记录实时生成，不保存文件，每次都反映最新内容；预览将在新窗口中打开。":
    "\"Download\" and \"Preview\" are generated live from this lesson's current implementation record, so they always reflect the latest version. Preview opens in a new window.",
  "上传课程实施文件（将覆盖本课时当前的实施记录）": "Upload an implementation file (overwrites this lesson's current record)",
  "上传的文件将替换本课时当前的实施记录内容，此操作无法撤销。": "The uploaded file replaces this lesson's current implementation record. This cannot be undone.",
  "课程设计文件": "Course design file",
  "计划整体点评": "Overall design review",
  "计划": "Design ",
  "手动迁移内容": "Content to migrate manually",
  "分课时设计 · 课时 {n}": "Lesson design · Lesson {n}",
  "课时 {n} · 课程实施文件": "Lesson {n} · Implementation file",
  "课时 {n} · 实施记录": "Lesson {n} · Implementation record",
  "课时 {n} · 支撑材料": "Lesson {n} · Supporting materials",
  "实施整体点评": "Overall implementation review ",
  "管理": "Admin",
  "年份": "Year",
  "学季": "Term",
  "乡土主题": "Theme",
  "年级": "Grade",
  "学生人数": "Students",
  "执教人": "Instructor",
  "预计课时": "Planned lessons",
  "已恢复登录超时前未保存的内容，请检查后保存。": "Restored unsaved content from before your session timed out. Please check it and save.",
  "加载课程设计详情失败。": "Failed to load the course design.",
  "欣欣小助手已修改了本课程设计，但当前页面有未保存的修改：保存将覆盖助手的修改；如需查看助手的修改，请放弃当前修改并刷新页面。":
    "Xinxin Assistant has changed this course design, but this page has unsaved changes. Saving will overwrite the assistant's changes; to see them, discard your changes and refresh the page.",
  "向欣欣小助手提问前自动保存失败：{0}": "Auto-save before asking Xinxin Assistant failed: {0}",
  "已自动保存，欣欣小助手将基于保存后的内容回答。": "Auto-saved. Xinxin Assistant will answer based on the saved content.",
  "课程设计已提交待点评。": "Course design submitted for review.",
  "已保存。": "Saved.",
  "确定删除手动迁移板块吗？此操作无法撤销。": "Delete the manual-migration section? This cannot be undone.",
  "删除手动迁移板块失败。": "Failed to delete the manual-migration section.",
  "确定停用「{plan.title}」吗？停用后该课程设计将从公开列表中隐藏，仅本人与管理员可见。":
    "Deactivate \"{plan.title}\"? It will be hidden from public lists and visible only to its author and admins.",
  "以下内容来自旧版模板，新版模板中没有对应字段，请手动将需要保留的内容复制到相应板块后删除本板块。本板块不会包含在下载的文档中。":
    "The content below comes from an old template and has no matching field in the new one. Copy anything you want to keep into the right sections, then delete this section. It is not included in downloaded documents.",
  "删除本板块": "Delete this section",
  "实施记录 · 课时 {n}": "Implementation record · Lesson {n}",
  "课程实施文件 · 课时 {n}": "Implementation file · Lesson {n}",
  "支撑材料 · 课时 {n}": "Supporting materials · Lesson {n}",
  "管理员操作": "Admin actions",
  "取消优秀案例标记": "Unmark as exemplary",
  "停用状态": "Deactivated",
  "有未保存的内容，确定要离开吗？": "You have unsaved changes. Leave anyway?",
  "· {plan.year} · 状态：": "· {plan.year} · Status: ",
  " · 优秀案例": " · Exemplary",
  "该课程设计已被管理员停用，如需修改请联系管理员。": "This course design was deactivated by an admin. Contact an admin to make changes.",
  "显示导航（有新的点评）": "Show navigation (new reviews)",
  "计划整体点评有新的点评": "New reviews on the overall design",
  "分课时设计": " Lesson design",
  "课时 {n}": " Lesson {n}",
  "尚未设置预计课时": "Planned lessons not set",
  "有新的点评": "New reviews",
  "实施整体点评有新的点评": "New reviews on the overall implementation",
  "实施": "Implementation ",
  "实施记录": "Implementation record",
  "支撑材料": "Supporting materials",

  // profile
  "加载个人信息失败。": "Failed to load your profile.",
  "两次输入的新密码不一致。": "The new passwords don't match.",
  "新密码至少需要6个字符。": "The new password must be at least 6 characters.",
  "请先选择所在学校。": "Please select your school first.",
  "个人信息已更新。": "Profile updated.",
  "个人信息": "Profile",
  "修改您自己的账号信息。": "Edit your own account details.",
  "新密码确认": "Confirm new password",

  // register
  "请填写!": "Required!",
  "邮件地址不正确": "Invalid email address",
  "用户名应含3至20个字节": "Username must be 3-20 characters",
  "密码应含6至40个字节": "Password must be 6-40 characters",
  "请选择所在学校。": "Please select your school.",
  "账号创建成功，请登录。": "Account created. Please log in.",
  "注册成功": "Signed up",
  "前往登录": "Go to login",
  "创建账号": "Create account",
  "加入乡土智课系统": "Join Local Curriculum Studio",
  "电子邮箱": "Email ",
  "已有账号？": "Already have an account?",
  "立即登录": "Log in now",

  // reset
  "请再次确认密码。": "Please confirm the password.",
  "密码已经成功重置": "Password reset successfully",
  "该邮箱尚未注册，请确认后重试。": "This email isn't registered. Please check and try again.",
  "密码重置失败，请重试。": "Password reset failed, please try again.",
  "重置密码": "Reset password",
  "请输入您的注册邮箱和新密码": "Enter your registered email and a new password",
  "注册邮箱": "Registered email",
  "新密码": "New password",
  "新密码再确认": "Confirm new password",
  "提交": "Submit",
  "返回登录": "Back to login",
};
export default en;
